export default __webpack_public_path__ + "static/media/stancare03.c49e97cb.png";